export default () => ({
    locale: 'en',
    locales: [],
    pageLocales: [],
});
